import { UPDATE_HYDRA_SEGMENT } from '../../SearchPage/redux/action-types';
import {
  IHomeStoreState,
} from './types';

const initialState: IHomeStoreState = {
  offers: [],
  template: {},
  hydraSegments : {}
}

export default function HomepageReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_OFFERS': 
      return {
        ...state,
        offers: action.offers
      }
    case 'UPDATE_TEMPLATE':
      return {
        ...state,
        template: action.template
      }

    case UPDATE_HYDRA_SEGMENT:
      return {
        ...state,
        hydraSegments: action.hydraSegments
      }
      
    default:
      return state;
  }
}